import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { splitErrorMessageForToast } from "@/lib/error-debug";

declare module "@tanstack/react-query" {
	interface Register {
		queryMeta: {
			suppressError?: boolean;
		};
		mutationMeta: {
			/**
			 * @default true
			 */
			autoInvalidate?: boolean;
			success?: {
				/**
				 * success message
				 */
				message?: string;
				/**
				 * @default true
				 */
				enabled?: boolean;
			};
			error?: {
				/**
				 * error message
				 */
				message?: string;
				/**
				 * @default true
				 */
				enabled?: boolean;
			};
		};
	}
}

export const maxRetries = process.env.NODE_ENV === "production" ? 3 : 0;

export const createQueryClient = () => {
	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				retry: maxRetries,
				refetchOnWindowFocus: true,
				experimental_prefetchInRender: true,
			},
		},
		queryCache: new QueryCache({
			onError: (error, query) => {
				if (!query.meta?.suppressError) {
					if (error instanceof Error) {
						const { title, description } = splitErrorMessageForToast(error.message);
						toast.error(title, description ? { description } : undefined);
					} else {
						console.error(error);
					}
				}
			},
		}),
		mutationCache: new MutationCache({
			// onMutate: (variables, mutation) => {
			// 	if (
			// 		typeof variables === "string" &&
			// 		mutation.meta?.optimistic === true
			// 	) {
			// 		console.log(mutation.mutationId);
			// 		queryClient.setQueryData(
			// 			mutation.mutationId,
			// 			prev => prev.filter(item => item !== variables)
			// 		);
			// 	}
			// },
			onSuccess: (_data, _variables, _context, mutation) => {
				const keyToInvalidate = mutation.options.mutationKey?.[0];
				const autoInvalidateMeta = mutation.meta?.autoInvalidate ?? true;

				if (keyToInvalidate && autoInvalidateMeta) {
					queryClient.invalidateQueries({
						queryKey: [keyToInvalidate],
					});
				}

				const { success } = mutation.meta || {};

				if (success && success?.enabled !== false && success.message) {
					toast.success(success.message, {
						description: success.message,
					});
				}
			},
			onError(_error, _variables, _context, mutation) {
				const { error } = mutation.meta || {};

				if (_error.message && error?.enabled !== false) {
					console.log(_error.name, _error.message);
					const { title, description } = splitErrorMessageForToast(_error.message);
					// try {
					// 	const errorData = JSON.parse(_error.message) as ZodErrorFromServer;
					// }
					toast.error(error?.message || title, {
						description: error?.message ? _error.message : description,
					});
				}
			},
		}),
	});

	return queryClient;
};
